<template >
    <div class="identify-wrap">
        <div class="form">
            <div class="item">
                <label>姓名</label>
                <div class="input">
                    <input type="text" v-model="form.real_name" :disabled="form.is_real_name == 1" placeholder="请输入">
                </div>
            </div>
            <div class="item">
                <label>身份证号</label>
                <div class="input">
                    <input type="text" v-model="form.id_card_no" :disabled="form.is_real_name == 1" placeholder="请输入">
                </div>
            </div>
            <div class="btn-box td-f">
                <Btn class="btn td-f1 td-fcc" loading @confirmEvent="submitForm">确定</Btn>
            </div>
        </div>
    </div>
</template>

<script>
import Lockr from 'lockr'
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            countDown: 60,
            is_wait: false,
            code_btn_text: "获取验证码",
            form: {
                real_name: '',
                id_card_no: '',
                id_card_photo_front: ''
            }
        };
    },
    mounted() {
        this._initFormData();
    },
    /** 方法 */
    methods: {
        _onBack() {
            this.$router.back();
        },
        
        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if(pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({path, query});
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        _initFormData() {
            if (this.userInfo) {
                this.form = {
                    real_name: this.userInfo.real_name || '',
                    id_card_no: this.userInfo.id_card_no || '',
                    is_real_name: this.userInfo.is_real_name || 0,
                    id_card_photo_front: this.userInfo.id_card_photo_front || ''
                }
            }
        },

        // 提交表单
        async submitForm (done) {

            if (this.form.is_real_name == 1) {
                return this._onBack();
            }
            let {real_name, id_card_no, id_card_photo_front} = this.form
            if (!real_name) {
                this.Message({
                    title: '请输入姓名'
                })
                done&&done()
                return
            }
            if (!id_card_no) {
                this.Message({
                    title: '请输入身份证号'
                })
                done&&done()
                return
            }

            let url = this.API.check_real_name;
            let params = {
                real_name,
                id_card_no,
                id_card_photo_front,
            };
            let result = await this.$post(url, params);
            done();
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.$store.dispatch("UserInfo", true);
                this.Message({
                    title: result.msg,
                    time: 2000,
                    onClose: ()=>{
                        this._onBack();
                    }
                })
            } else {
                this.Message({
                    title: result.msg,
                });
            }
            
        }
    },
};
</script>

<style lang="less" scoped>
.identify-wrap {
    .form{
        padding: 10px 15px;
        .item {
            padding: 0 10px;
            height: 50px;
            border-radius: 5px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;

            label {
                margin-right: 10px;
                font-size: 15px;
                color: #333;
                flex-shrink: 0;
            }
            .input{
                flex: 1;
                height: 50px;
            }
            input {
                width: 100%;
                line-height: 50px;
                font-size: 14px;
                color: #333;
                text-align: right;
            }
            .code{
                min-width: 80px;
                text-align: center;
                font-size: 14px;
                color: #7181eb;
                flex-shrink: 0;
                line-height: 14px;
                padding-left: 10px;
                margin-left: 10px;
                border-left: solid #7181eb 1px;
            }
        }
        .item-tips{
            display: flex;
            flex-direction: column;
            padding-top: 15px;
            img{
                width: 14px;
                height: 14px;
                display: block;
                margin-right: 5px;
            }
            span{
                font-size: 12px;
                color: #999;
                line-height: 2;
            }
        }
        .btn {
            height: 40px;
            background: linear-gradient(225deg,#9cb2f4, #6472e8);
            border-radius: 3px;
            font-size: 15px;
            color: #fff;
            text-align: center;
            margin-top: 40px;
        }
    }
}
</style>